'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alertContainer = require('./alert-container');

var _alertContainer2 = _interopRequireDefault(_alertContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _alertContainer2.default;


//////////////////
// WEBPACK FOOTER
// ./~/react-alert/dist/index.js
// module id = 943
// module chunks = 0